import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="w-full px-4 py-8 md:py-10 bg-slate-900 border-t border-slate-800" data-id="element-62">
        <div className="max-w-4xl mx-auto" data-id="element-63">
          <div className="flex flex-col items-center gap-6 text-gray-400 text-sm" data-id="element-64">
            <p className="text-center" data-id="element-65">
              © 2024 Viral Video Machine IA. Todos los derechos reservados.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6" data-id="element-66">
              <button onClick={() => setShowPrivacy(true)} className="hover:text-purple-400 transition-colors text-center" data-id="element-67">
                Política de Privacidad
              </button>
              <button onClick={() => setShowTerms(true)} className="hover:text-purple-400 transition-colors text-center" data-id="element-68">
                Términos de Servicio
              </button>
              <a href="mailto:support@truemarketer.com" className="hover:text-purple-400 transition-colors text-center" data-id="element-69">
                support@truemarketer.com
              </a>
            </div>
          </div>
        </div>
      </footer>
      {showPrivacy && <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" data-id="element-70">
          <div className="bg-slate-800 rounded-2xl max-w-3xl w-full max-h-[80vh] overflow-y-auto" data-id="element-71">
            <div className="sticky top-0 bg-slate-800 border-b border-slate-700 p-6 flex justify-between items-center" data-id="element-72">
              <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-73">
                Política de Privacidad
              </h2>
              <button onClick={() => setShowPrivacy(false)} className="text-gray-400 hover:text-white transition-colors" data-id="element-74">
                <XIcon className="w-6 h-6" data-id="element-75" />
              </button>
            </div>
            <div className="p-6 text-gray-300 space-y-4" data-id="element-76">
              <p className="text-sm text-gray-400" data-id="element-77">
                Última actualización: {new Date().toLocaleDateString()}
              </p>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-78">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-79">
                Recopilamos información que usted nos proporciona directamente,
                incluyendo nombre, dirección de correo electrónico, información
                de pago y cualquier otra información que elija proporcionarnos.
              </p>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-80">
                2. Cómo Usamos Su Información
              </h3>
              <p data-id="element-81">Utilizamos la información que recopilamos para:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-82">
                <li data-id="element-83">Procesar sus pedidos y proporcionar acceso al producto</li>
                <li data-id="element-84">Enviarle actualizaciones y comunicaciones del producto</li>
                <li data-id="element-85">Mejorar nuestros servicios y experiencia del usuario</li>
                <li data-id="element-86">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-87">
                3. Compartir Información
              </h3>
              <p data-id="element-88">
                No vendemos su información personal. Podemos compartir su
                información con proveedores de servicios que nos ayudan a operar
                nuestro negocio, procesadores de pagos y según lo requiera la
                ley.
              </p>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-89">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-90">
                Implementamos medidas de seguridad razonables para proteger su
                información personal. Sin embargo, ningún método de transmisión
                por Internet es 100% seguro.
              </p>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-91">
                5. Sus Derechos
              </h3>
              <p data-id="element-92">
                Tiene derecho a acceder, corregir o eliminar su información
                personal. Para ejercer estos derechos, contáctenos en
                support@truemarketer.com
              </p>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-93">
                6. Cookies
              </h3>
              <p data-id="element-94">
                Utilizamos cookies y tecnologías similares para mejorar su
                experiencia en nuestro sitio web y analizar el uso del sitio.
              </p>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-95">
                7. Cambios a Esta Política
              </h3>
              <p data-id="element-96">
                Podemos actualizar esta política de privacidad ocasionalmente.
                Le notificaremos sobre cambios significativos publicando la
                nueva política en esta página.
              </p>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-97">
                8. Contáctenos
              </h3>
              <p data-id="element-98">
                Si tiene preguntas sobre esta política de privacidad,
                contáctenos en: support@truemarketer.com
              </p>
            </div>
          </div>
        </div>}
      {showTerms && <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" data-id="element-99">
          <div className="bg-slate-800 rounded-2xl max-w-3xl w-full max-h-[80vh] overflow-y-auto" data-id="element-100">
            <div className="sticky top-0 bg-slate-800 border-b border-slate-700 p-6 flex justify-between items-center" data-id="element-101">
              <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-102">
                Términos de Servicio
              </h2>
              <button onClick={() => setShowTerms(false)} className="text-gray-400 hover:text-white transition-colors" data-id="element-103">
                <XIcon className="w-6 h-6" data-id="element-104" />
              </button>
            </div>
            <div className="p-6 text-gray-300 space-y-4" data-id="element-105">
              <p className="text-sm text-gray-400" data-id="element-106">
                Última actualización: {new Date().toLocaleDateString()}
              </p>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-107">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-108">
                Al acceder y usar Viral Video Machine IA, usted acepta estar
                sujeto a estos Términos de Servicio y todas las leyes y
                regulaciones aplicables.
              </p>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-109">
                2. Descripción del Servicio
              </h3>
              <p data-id="element-110">
                Viral Video Machine IA proporciona un sistema y plantillas para
                ayudar a los usuarios a crear contenido de video utilizando
                herramientas de inteligencia artificial.
              </p>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-111">
                3. Licencia de Uso
              </h3>
              <p data-id="element-112">
                Se le otorga una licencia no exclusiva, no transferible y
                revocable para usar el producto para sus propios fines
                comerciales o personales.
              </p>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-113">
                4. Restricciones de Uso
              </h3>
              <p data-id="element-114">Usted acepta no:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-115">
                <li data-id="element-116">Compartir su acceso con otros usuarios</li>
                <li data-id="element-117">Revender o redistribuir el producto</li>
                <li data-id="element-118">Realizar ingeniería inversa del sistema</li>
                <li data-id="element-119">Usar el producto para fines ilegales o no autorizados</li>
              </ul>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-120">
                5. Pagos y Reembolsos
              </h3>
              <p data-id="element-121">
                Los pagos se procesan de forma segura a través de nuestros
                proveedores de pago. Ofrecemos una garantía de devolución de
                dinero de 30 días según se describe en nuestra página de
                producto.
              </p>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-122">
                6. Propiedad Intelectual
              </h3>
              <p data-id="element-123">
                Todo el contenido, plantillas y materiales proporcionados son
                propiedad de Viral Video Machine IA y están protegidos por leyes
                de propiedad intelectual.
              </p>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-124">
                7. Descargo de Responsabilidad
              </h3>
              <p data-id="element-125">
                El servicio se proporciona "tal cual" sin garantías de ningún
                tipo. No garantizamos resultados específicos del uso del
                producto.
              </p>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-126">
                8. Limitación de Responsabilidad
              </h3>
              <p data-id="element-127">
                En ningún caso seremos responsables de daños indirectos,
                incidentales, especiales o consecuentes que resulten del uso o
                la imposibilidad de usar el servicio.
              </p>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-128">
                9. Modificaciones
              </h3>
              <p data-id="element-129">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. Los cambios entrarán en vigor inmediatamente
                después de su publicación.
              </p>
              <h3 className="text-xl font-semibold text-white mt-6" data-id="element-130">
                10. Contacto
              </h3>
              <p data-id="element-131">
                Para preguntas sobre estos términos, contáctenos en:
                support@truemarketer.com
              </p>
            </div>
          </div>
        </div>}
    </>;
}